import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const RelationDescriptionModal = ({ isOpen, onClose, onSave, topic }) => {
  const [relationDescription, setRelationDescription] = useState('');

  useEffect(() => {
    if (topic) {
      setRelationDescription(topic.relation_description || '');
    }
  }, [topic]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...topic,
      relation_description: relationDescription.trim()
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-4">
        <h2 className="text-xl font-bold mb-4">
          {topic?.relation_description ? 'Edit Relationship' : 'Add Relationship'}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2 text-neutral-700">
              How does "<span className="font-medium">{topic?.name}</span>" relate to this basket?
            </label>
            <textarea
              value={relationDescription}
              onChange={(e) => setRelationDescription(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-cranberry-700 min-h-[120px]"
              placeholder="Describe the relationship between this topic and the basket..."
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-neutral-300 rounded-lg hover:bg-neutral-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-cranberry-700 text-white rounded-lg hover:bg-cranberry-600"
              disabled={!relationDescription.trim()}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default RelationDescriptionModal; 